<template>
  <div class="map-wrapper" :class="userDevice">
    <div class="map-container">
      <template v-if="userDevice !== 'mobile'">
        <map-header-template is-show-cnt :user-count="userCount" coding-party></map-header-template>
        <div class="second-row">
          <div class="second">
            <div class="div-icon">
              <div class="div-circle circle-wait">
                <p>진행</p>
              </div>
              <div class="div-circle circle-proceeding">
                <div>
                  <p>미션</p>
                  <p>시도</p>
                </div>
              </div>
              <div class="div-circle circle-succeeded">
                <p>성공</p>
              </div>
            </div>
            <map-stage-template
                            v-for="(category, ci) in title"
                            :key="category"
                            @showModal="showModal"
                            @openCertification="openCertification"
                            is-coding-party
                            :title="category"
                            :desc="desc[ci]"
                            :missions="missions[ci]"></map-stage-template>
            <img class="complete" :src="medal[complete ? 'complete' : 'gray']" @click="showCompleteCert">
          </div>
        </div>
      </template>
      <template v-else>
        <img @click="showModal('map-alert-template', '본 서비스는 PC / 태블릿에서<br/>사용 가능합니다.')" src="../assets/images/map/mobile_bg_cp.jpg">
      </template>
    </div>

    <!-- 코딩파티 최초참가시 사용자정보 입력팝업창 -->
    <map-info-input-template
      v-if="isNonUserInfo"
      @saveUser="saveUser"
      :userDevice="userDevice"
      :courseCat="courseCat"
      :showCertPopup="showCertPopup"
    />
    <!-- 공통모달창 -->
    <component
      v-if="isShowModal"
      :is="modal"
      :data="modalData"
      @close="isShowModal = false;"
      :userDevice="userDevice"
      :confirm="confirm"></component>

    <win-popup ref="winPopup" @onClose="val => evtCloseWinPopup(val)" @onRecvEvtFromWinPop="val => onRecvWinPop(val)" />
  </div>
</template>


<script>
  import { axios, was } from '@/lib/axios';
  window.axios = axios;
  import mobileDetect from 'mobile-detect'

  // 학습관련
  import mapStageTemplate from './map/MapPartialStage'
  import certificateTemplate from './map/MapPartialCertificate'
  import mapHeaderTemplate from './map/MapPartialHeader'
  import mapInfoInputTemplate from './map/MapInfoInputPopup'
  import mapAlertTemplate from './map/MapAlert'
  import WinPopup from './WinPopup';

  import { title, desc } from '../data.json'

  export default {
    name: "CodingPartyMap",
    components: {
      mapStageTemplate,
      certificateTemplate,
      mapHeaderTemplate,
      mapInfoInputTemplate,
      mapAlertTemplate,
      WinPopup,
    },
    data() {
      return {
        title,
        desc,
        missions: (() => {
          const arr1 = []
          for (let i = 1; i <= 4; i++) {
            const arr2 = [];
            for (let z = 1; z <= 10; z++) {
              arr2.push([`ESOF01_1_${i}_${z}`, 0]);
            }
            arr1.push(arr2);
          }
          return arr1;
        })(),
        isShowModal: false,
        isLoginShowModal: false,
        modal: '',
        modalData: null,
        popupData: {},
        isNonUserInfo: false,
        userCount: localStorage.getItem('party_user_count_1') || 0,
        isLoading: false,
        userDevice: 'pc',
        courseCat: 'ESOF01',
        confirm: '',
        medal: {
          complete: require('../assets/images/map/medal_complete.png'),
          gray: require('../assets/images/map/medal_complete_gray.png')
        }
      }
    },
    computed: {
      complete () {
        return !this.missions.flatMap(e => e).some(e => e[1] !== 2)
      }
    },
    created() {

      // 사용자 접속기기 체크
      const MD = new mobileDetect(window.navigator.userAgent);
      if (MD.tablet() !== null) this.userDevice = 'tablet';
      else if (MD.mobile() !== null) this.userDevice = 'mobile'

      if (typeof parent.codingPartyCnt === 'function') {
        parent.codingPartyCnt(this.userCount)
      }

      // 학습 참가자수
      axios.get(`/coding-party/count1?${this.randomId()}`)
      .then(res => {
          this.userCount = this.addComma(res.data)
          localStorage.setItem('party_user_count_1', this.userCount);

          if (typeof parent.codingPartyCnt === 'function') {
              parent.codingPartyCnt(this.userCount)
          }
      })
    },
    async mounted () {
        this.publicIP = await this.getClientIP();

        await was
            .post(
                `${this.API_SERVER_URL}/manage/codmos/user/party_init`,
                {},
            )
            .then(async (response) => {
                if (response.status === 200) {
                    if (response.data.code === "1000") {
                        if (response.data.trialLoginUser) {
                            this.lbcookie = response.data.trialLoginUser;
                            this.setCookie({
                                userType: 'party',
                                loginUserInfo: JSON.stringify({
                                    lbparty: this.lbcookie,
                                }),
                                publicIP: this.publicIP,
                                isLogin: true
                            }, 9e9)
                        }
                    } else {
                        const userInfo = JSON.parse(this.getCookie('dduNonLoginUserInfo') || '{}');
                        if (userInfo) {
                            this.lbcookie = userInfo.lbparty;
                        }

                        this.setCookie({
                            isLogin: false
                        })
                        if (!this.lbcookie) {
                            this.isNonUserInfo = true;
                        }
                    }
                    if (this.lbcookie) {
                        this.isLoading = true;
                        await this.setClearData();
                    }
                }
            })
            .catch(e => {
                console.error(e)
            });
        //console.log(`[LBCookie] ${JSON.stringify(lbcookie)}`);

        // 인증서 테스트용
        // const data = JSON.parse(`{"docs":[{"courseCat":"ESOF01","mapCat":"1","stageCat":"1","missionCat":"1","isCleared":1,"usedBlockCount":4,"goalBlockCount":4,"startTime":"2021-10-02 09:52:58","settingTime":9,"runningTime":3,"concept":"순차"},{"courseCat":"ESOF01","mapCat":"1","stageCat":"1","missionCat":"2","isCleared":0,"usedBlockCount":5,"goalBlockCount":8,"startTime":"2021-10-02 09:53:12","settingTime":766,"runningTime":3,"concept":"순차"},{"courseCat":"ESOF01","mapCat":"1","stageCat":"1","missionCat":"2","isCleared":1,"usedBlockCount":8,"goalBlockCount":8,"startTime":"2021-10-02 10:06:02","settingTime":6,"runningTime":5,"concept":"순차"},{"courseCat":"ESOF01","mapCat":"1","stageCat":"1","missionCat":"3","isCleared":0,"usedBlockCount":0,"goalBlockCount":7,"startTime":"2021-10-02 10:06:16","settingTime":2,"runningTime":0,"concept":"순차"},{"courseCat":"ESOF01","mapCat":"1","stageCat":"1","missionCat":"3","isCleared":1,"usedBlockCount":6,"goalBlockCount":7,"startTime":"2021-10-02 10:06:20","settingTime":24,"runningTime":4,"concept":"순차"},{"courseCat":"ESOF01","mapCat":"1","stageCat":"1","missionCat":"4","isCleared":1,"usedBlockCount":5,"goalBlockCount":6,"startTime":"2021-10-02 10:07:15","settingTime":20,"runningTime":3,"concept":"순차"},{"courseCat":"ESOF01","mapCat":"1","stageCat":"1","missionCat":"5","isCleared":1,"usedBlockCount":4,"goalBlockCount":5,"startTime":"2021-10-02 10:07:55","settingTime":15,"runningTime":3,"concept":"순차"}],"code":"1000","msg":"RET_SUCCESS"}`);
        // data.docs.forEach(e => {
        //     const IS_CLEARED = e.isCleared ? 2 : 1
        //     if (IS_CLEARED > this.missions[e.stageCat - 1][e.missionCat - 1][1])
        //     this.$set(this.missions[e.stageCat - 1][e.missionCat - 1], 1, IS_CLEARED)
        // });
        // return;

        // 코딩파티 진행시 하단 구문 활성화
        return;

        // 코딩파티 종료시 하단 구문 활성화
        // this.showModal('map-alert-template', '2018 온라인 코딩파티 시즌 2가 종료되었습니다.<br>' +
        //   '많은 성원에 힘입어 스테이지에<br>' +
        //   '총 <font color="#000" style="font-weight: 700;">511,673</font>번 참여했습니다.<br>' +
        //   '확인 버튼을 누르면 미션을 다시 해볼 수 있습니다.',
        //   () => {
        //     const COOKIE = this.getCookie()

        //     if (typeof COOKIE.lbparty !== 'undefined') {
        //       this.isLoading = false
        //       axios.get(
        //         `${this.API_SERVER_URL}/manage/codmos/record/party/ESOF01/1/0/0?${this.randomId()}`,
        //         {
        //           headers: {
        //             lbcookie: this.getCookie('lbparty')
        //           }
        //         })
        //         .then(res => {
        //           if (res.data.code !== '1000' || !Array.isArray(res.data.docs)) return
        //           res.data.docs.forEach(e => {
        //             const IS_CLEARED = e.isCleared ? 2 : 1
        //             if (IS_CLEARED > this.missions[e.stageCat - 1][e.missionCat - 1][1])
        //               this.missions[e.stageCat - 1][e.missionCat - 1][1] = IS_CLEARED
        //           })
        //         })
        //         .finally(() => {
        //           this.isLoading = true
        //         })
        //     }
        //     else {
        //       this.isNonUserInfo = true
        //     }
        //   });
    },
    methods: {
      addComma(num) {
            if (num === null || isNaN(num)) return num
            if ((num + '').indexOf('.') > -1) num = num.toFixed(3)
            return (num + '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          },
      showCompleteCert () {
        if (this.complete) {
          this.openCertification({ title: 'complete', isTrial: false });
        } else {
          this.showModal('map-alert-template', '미션을 완료 해주세요.');
        }
      },
      openCertification(data) {
        this.popupData = data;
        if (this.getCookie('isLogin') === 'true') {
          this.isNonUserInfo = true;
        } else {
          this.showCertPopup(data);
        }
      },
      showCertPopup(data) {
        this.popupUri = new URL(`${location.origin}/codmos/certificate`);
        const popup = this.$refs.winPopup.openWinPop(this.popupUri, 1200, 750);
        popup.onload = () => {
          if (g_winPopup)  {
            this.$refs.winPopup.sendEvtToChild(data);
          }
        }
      },
      showModal(template, data, func) {
        this.confirm = func;
        this.modalData = data;
        this.modal = template;
        this.isShowModal = true;
      },
      setCookie(obj, hours = 3) {
        try{
          let date = new Date();
          if (this.isTrial) {
            let days = 30;
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));  // Day기준
          } else {
            date.setTime(date.getTime() + (hours * 3600 * 1000));
          }

          let expires = "expires=" + date.toGMTString() +";";
          //let expires = "expires=" + date.toGMTString() +";"; // toGMTString 안되면 toUTCString 사용하여 테스틑 해볼것

          for (let key in obj) {
            // Ver1(코딩파티2018년버전)
            // document.cookie = `${key}=${obj[key]}; path=/; expires=Thur, 31 Dec 2099 23:59:59 UTC;`;  // 쿠키 만료 시간 무제한

            // Ver2(코딩파티2019년버전)
            let cookieString = `${key}=${obj[key]}; path=/; ${expires}`;
            document.cookie = cookieString;  // 쿠키 만료 시간(3시간)
            //console.log(`[Cookie] String >> ${cookieString}`);
          }
        }catch(e){
          console.log(`[Cookie] Exception : ${JSON.stringify(e)}`);
        }
      },
      async setClearData() {
          axios
            .get(
                `${this.API_SERVER_URL}/manage/codmos/record/party/ESOF01/1/0/0?${this.randomId()}`,
                {
                    headers: { lbcookie: this.lbcookie }
                }
            )
            .then(res => {
                if (res.data.code !== '1000' || !Array.isArray(res.data.docs)) return
                res.data.docs.forEach(e => {
                    const IS_CLEARED = e.isCleared ? 2 : 1
                    if (IS_CLEARED > this.missions[e.stageCat - 1][e.missionCat - 1][1])
                    this.$set(this.missions[e.stageCat - 1][e.missionCat - 1], 1, IS_CLEARED)
                })
            }).catch(() => {
                alert('유저 정보가 올바르지 않습니다.');
                location.reload();
            })
      },
      saveUser(req) {
        this.isNonUserInfo = false;
        this.isLoading = true;
        if (req.showCertPopup) {
          req.showCertPopup(this.popupData);
        }
      },
      async getClientIP() {
        return (await axios.get('https://jsonip.com')).data.ip;
      },
    }
  }
</script>

<style>
  @import '../assets/styles/map/map_default.css';
</style>
<style lang="scss">
  @import '../assets/styles/map/map_tablet';
  @import '../assets/styles/map/map_mobile';
</style>
<style scoped>
  .complete {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/CodingPartyMap.vue